import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import './SettingsStyles.scss';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import classNames from 'classnames';
import Loader from '../../../components/base/Loader/Loader';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import TextInput from '../../../components/fields/TextInput/TextInput';
import { Button, Icons } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import {
  getPaginationOpts,
  getResponseError,
  responseLogWithNotification, useFilterForm,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import { deleteSettings, loadSettings } from '../actions';
import { errorNotification, successNotification } from '../../Notifications/notificationDecorator';
import { showGlobalConfirm } from '../../System/actions';
import TooltipWithPortal from '../../../components/base/Tooltip/TooltipWithPortal';
import Tooltip from '../../../components/base/Tooltip/Tooltip';
import Grid from '../../../components/base/Grid/Grid';
import SettingsForm from './SettingsForm';
import { getSettingsData } from '../reducer';
import { SETTINGS_MODULE } from '../../../configs/moduleNames';

export default function SettingsPage(props) {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();
  const store = useStore();
  const [showForm, setShowForm] = useState(false);
  const [selectedCat, setSelectedCat] = useState(null);
  const [selected, setSelected] = useState(null);

  const { updatePeriod } = useSelector(getSystemData);
  const {
    loadingCreateSettings,
    loadingDeleteSettings,
    loadingSettingsList,
    loadingEditSettings,
    loadingCurrentSettings,
    settingsList = [],
  } = useSelector(getSettingsData);

  const loadData = opts => {
    const filterData = getValues();
    const paginationOpts = getPaginationOpts(store.getState()[SETTINGS_MODULE].settingsListMeta, opts); // костыль внедрен из за потери контекста в updatePeriod. Он сохранял первую функцию
    const requestData = {
      ...paginationOpts,
      filter: filterData,
    };
    const p1 = dispatch(loadSettings(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);
  const { getValues, control } = useFilterForm({}, loadData, ['user_id']);

  const handleCreate = event => {
    setShowForm(true);
    setSelected(null);
    event.preventDefault();
    event.stopPropagation();
  };

  const handleEdit = item => event => {
    handleClose();
    if (!item) {
      return;
    }
    setSelected(item);
    setShowForm(true);
    event.preventDefault();
    event.stopPropagation();
  };

  const handleDelete = item => event => {
    dispatch(showGlobalConfirm({
      confirmMessage: `Удаление настройки ${item.key}`,
      confirmButtonText: 'Удалить',
      confirmClassName: 'remove-preset',
    })).then(() => {
      dispatch(deleteSettings(item.id)).then(() => {
        loadData();
        successNotification('Удаление настройки', 'Удаление прошло успешно');
      }).catch(response => {
        errorNotification('Удаление настройки', getResponseError(response));
      });
    }).catch(() => {});

    event.preventDefault();
    event.stopPropagation();
    return false;
  };

  const handleClose = () => {
    setShowForm(false);
    setSelected(null);
  };
  const search = '';
  const getCategoryList = () => {
    const filteredOptionsList = search ? settingsList.filter(option => (String(option.name).toLowerCase().includes(String(search).toLowerCase()) || String(option.name_label).toLowerCase().includes(String(search).toLowerCase()))) : [...settingsList];
    const category = filteredOptionsList.reduce((prev, current) => {
      const index = prev.findIndex(item => item.group === current.group);
      if (index >= 0) {
        prev[index].list.push(current);
      } else {
        prev.push({ group: current.group, group_label: current.group_label, list: [current] });
      }
      return prev;
    }, []);
    const sortedCategory = category.sort((a, b) => {
      if (a.group_label < b.group_label) { return -1; }
      if (a.group_label > b.group_label) { return 1; }
      return 0;
    });
    if (sortedCategory && sortedCategory[0] && sortedCategory[0].group_label === '') {
      sortedCategory.push(sortedCategory.shift());
    }
    return sortedCategory;
  };

  const columnTooltipFormatter = a => (
    <Tooltip content={a.toString()} className="column-tooltip c300 tbl" />
  );

  const moreFormatter = (_, item) => (
    <TooltipWithPortal
      content={<Icons customIcon icon="more-vert" className="more-vert" />}
      classNamePortal="more-actions"
      tooltipContent={(
        <div className="more-wrapper">
          <Button variant="link" className="w-100 more-button" onClick={handleEdit(item)}>
            Редактировать
          </Button>
          {/* <Button variant="link" className="w-100 more-button delete" onClick={handleDelete(item)}> */}
          {/*  Удалить */}
          {/* </Button> */}
        </div>
      )}
      classNameWrapper="more-tooltip-wrapper"
      className="more-tooltip"
    />
  );

  const columns = [
    {
      dataField: 'name',
      text: 'Ключ опции',
      disableSort: true,
    },
    {
      dataField: 'name_label',
      text: 'Название',
      disableSort: true,
    },
    {
      dataField: 'payload',
      text: 'Значение',
      disableSort: true,
      formatter: columnTooltipFormatter,
    },
    {
      dataField: 'more',
      text: '',
      disableSort: true,
      formatter: moreFormatter,
      headerClassName: 'settings-column',
      dataClassName: 'settings-column',
    },
  ];

  const groups = getCategoryList();

  useEffect(() => {
    if (groups && groups.length) {
      setSelectedCat(selectedCat || groups[0]);
    }
  }, [groups]);

  const findGroup = selectedCat ? groups.find(i => i.group === selectedCat.group) : null;
  const selectedSettings = selectedCat && findGroup ? findGroup.list : [];

  return (
    <div className="page settings-page">
      <Loader loading={loadingCreateSettings || loadingDeleteSettings || loadingSettingsList || loadingEditSettings || loadingCurrentSettings} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.settings' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
            inputBefore={(
              <div className="search-wrapper">
                <Icons customIcon className="search" width={24} height={24} icon="search" />
              </div>
            )}
            inputProps={{
              value: search || '',
              onChange: e => {},
            }}
          />
          {/* <div className="filter-sep" /> */}
          {/* <Button variant="second" onClick={handleCreate}> */}
          {/*  <Icons */}
          {/*    customIcon */}
          {/*    className="file-download" */}
          {/*    width={24} */}
          {/*    height={24} */}
          {/*    icon="plus" */}
          {/*  /> */}
          {/* </Button> */}
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content settings-content">
          <div className="settings-category-wrapper frame">
            <div className="settings-category-header">Разделы</div>
            <div className="settings-category-list">
              {groups.map((item, key) => {
                const active = selectedCat ? selectedCat.group === item.group : false;
                return (
                  <div key={key} className={classNames('category-list-item', { active })} onClick={() => setSelectedCat(item)}>
                    <Tooltip content={item.group_label || 'Без категории'} className="option-tooltip" />
                  </div>
                );
              })}
            </div>
          </div>
          <div className="settings-list-wrapper frame">
            <div className="grid-wrapper">
              <div className="custom-scroll-theme sticky-table-wrapper">
                <Grid
                  onDoubleClickByRow={(item, event) => handleEdit(item)(event)}
                  data={selectedSettings}
                  columns={columns}
                  name="application-list"
                  settingsFormatter={moreFormatter}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      {showForm ? <SettingsForm key={selected && selected.key ? selected.key : ''} current={selected} close={handleClose} loadData={loadData} /> : null}
    </div>
  );
}
